var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreyNone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300.446,
    xmlns: "http://www.w3.org/2000/svg",
    height: 300.446,
    id: "screenshot-1d8af7ff-090f-80c0-8002-99231e622a94",
    viewBox: "-0.223 -0.223 300.446 300.446",
    style: {
      WebkitPrintColorAdjust: "exact"
    },
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-1d8af7ff-090f-80c0-8002-99231e622a94",
    height: 48,
    width: 48,
    rx: 0,
    ry: 0,
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-1d8af7ff-090f-80c0-8002-992328c474ea"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-1d8af7ff-090f-80c0-8002-992328c474ea"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M149.777,274.777C132.486,274.777,116.236,271.496,101.027,264.933C85.819,258.371,72.590,249.465,61.340,238.215C50.090,226.965,41.183,213.736,34.621,198.527C28.058,183.319,24.777,167.069,24.777,149.777C24.777,132.486,28.058,116.236,34.621,101.027C41.183,85.819,50.090,72.590,61.340,61.340C72.590,50.090,85.819,41.183,101.027,34.621C116.236,28.058,132.486,24.777,149.777,24.777C167.069,24.777,183.319,28.058,198.527,34.621C213.736,41.183,226.965,50.090,238.215,61.340C249.465,72.590,258.371,85.819,264.933,101.027C271.496,116.236,274.777,132.486,274.777,149.777C274.777,167.069,271.496,183.319,264.933,198.527C258.371,213.736,249.465,226.965,238.215,238.215C226.965,249.465,213.736,258.371,198.527,264.933C183.319,271.496,167.069,274.777,149.777,274.777ZL149.777,274.777ZM149.777,256.027C179.439,256.027,204.562,245.734,225.148,225.148C245.734,204.562,256.027,179.439,256.027,149.777C256.027,137.139,253.840,124.969,249.465,113.268C245.090,101.566,238.944,90.923,231.027,81.340L81.340,231.027C90.715,239.152,101.287,245.350,113.056,249.621C124.826,253.892,137.066,256.027,149.777,256.027ZL149.777,256.027ZM68.840,218.215L218.215,68.840C208.631,60.715,197.989,54.465,186.287,50.090C174.585,45.715,162.415,43.527,149.777,43.527C120.116,43.527,94.992,53.820,74.406,74.406C53.820,94.992,43.527,120.116,43.527,149.777C43.527,162.488,45.819,174.729,50.402,186.498C54.986,198.268,61.131,208.840,68.840,218.215ZL68.840,218.215Z",
    style: {
      fill: "rgb(87, 107, 124)",
      fillOpacity: 1
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyNone);
export default __webpack_public_path__ + "static/media/grey_none.29ea319a57f6bb07c6f98218629d45f7.svg";
export { ForwardRef as ReactComponent };